import authService from '../services/authService';
import { Platform } from 'react-native';

// Auth error event listeners
type AuthErrorListener = () => void;
const authErrorListeners: AuthErrorListener[] = [];

export const addAuthErrorListener = (listener: AuthErrorListener) => {
  authErrorListeners.push(listener);
  return () => {
    const index = authErrorListeners.indexOf(listener);
    if (index > -1) {
      authErrorListeners.splice(index, 1);
    }
  };
};

const notifyAuthErrorListeners = () => {
  authErrorListeners.forEach(listener => listener());
};

// Global error handler for authentication
export const handleAuthError = (error: any) => {
  if (error.message === 'Authentication required') {
    // Clear auth data
    authService.logout();

    // Notify all listeners that auth error occurred - this will trigger redirect to login
    notifyAuthErrorListeners();

    // For web platform, also dispatch a custom event for additional handling
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('auth-error'));
    }

    console.log('🔐 Authentication required - redirecting to login');
  }
};

// Wrapper for API calls that handles auth errors
export const withAuthErrorHandling = async <T>(apiCall: () => Promise<T>): Promise<T> => {
  try {
    return await apiCall();
  } catch (error: any) {
    handleAuthError(error);
    throw error;
  }
};
